<script>

    import Editor from "./../Editor";

    export default {

        extends: Editor,

        data()
        {
            return {
                moving: false,
            };
        },

        appearance: function()
        {
            return {
                icon: 'fa fa-fw fa-cubes',
                name: null,
            };
        },

        created()
        {
            this.initLoopData();
        },

        methods: {

            initLoopData()
            {
                if (!this.canvasBlock.options.loops)
                    this.$set(this.canvasBlock.options, 'loops', {});

                if (!this.canvasBlock.options.loops[this.loopKey])
                    this.$set(this.canvasBlock.options.loops, this.loopKey, {});

                if (!this.canvasBlock.options.loops[this.loopKey].items)
                    this.$set(this.canvasBlock.options.loops[this.loopKey], 'items', []);
            },

            startMoving()
            {
                // Deselect this as editing.
                this.selection.setSelection(null);
                this.selection.setEnabled(false);

                // Activate mode.
                this.moving = true;

                // Init sortable plugin.
                this.element.sortable({
                    items: this.itemSelector,
                });

                // Get original item indices.
                let originalOrderedChildren = [].concat(this.$children);

                //
                this.showMovingToast(originalOrderedChildren);
            },

            showMovingToast(originalOrderedChildren)
            {
                // Show instruction toast.
                this.toasted.show('<i class="fa fa-arrows-alt mr-2"></i> Sleep de items in de gewenste volgorde', {
                    duration: 1000000,
                    //type: 'error',
                    iconPack: 'fontawesome',
                    closeOnSwipe: false,
                    action: {
                        text: 'Gereed',
                        onClick: (e, toastObject) => this.saveMoving(toastObject, originalOrderedChildren),
                    },
                });
            },

            saveMoving(toast, originalOrderedChildren)
            {
                // Remove toast.
                toast.goAway(0);

                // Stop dragging plugin.
                this.element.sortable('destroy');

                //
                this.updateMoveIndices(originalOrderedChildren);

                // Enable selection.
                this.$pageComponent().selection.setEnabled(true);
            },

            updateMoveIndices(originalOrderedChildren)
            {
                // Get original data.
                let original = {
                    loopItems: [].concat(this.loopItems),
                    loopIndex2canvasBlocks: _.map(originalOrderedChildren, loopItemEditorComponent => loopItemEditorComponent.canvasBlocks),
                };

                // Remove loop items.
                this.loopItems.splice(0, this.loopItems.length);

                // Loop
                Array.from(originalOrderedChildren).forEach((childComponent, originalIndex) =>
                {
                    // Determine new index.
                    let newIndex = childComponent.element.closest(this.element.find(this.itemSelector)).index();

                    // Swap canvas blocks.
                    for(let canvasBlock of original.loopIndex2canvasBlocks[originalIndex])
                    {
                        // Determine key suffix (after "loop.x")
                        let keySuffix = canvasBlock.key.split('.').slice(2).join('.');

                        // Set new key.
                        this.$set(canvasBlock, 'key', this.loopKey + '.' + newIndex + '.' + keySuffix);
                    }

                    // Set in loop items.
                    this.loopItems[newIndex] = original.loopItems[originalIndex];
                });
            },

        },

        computed: {

			loopItems()
            {
                return this.canvasBlock.options.loops[this.loopKey].items;
            },

            loopKey()
            {
                return this.element.data('canvas-editable').loopKey || 'loop';
            },

            // TODO Rename such to panelComponentCtor?
            panelComponent()
            {
                return window.Vue.options.components['common-canvas-editor-canvas-document-editors-loop-looppanel'];
            },

            // TODO Code duplication. Move to Page component?
            toasted()
            {
                return window.canvasEditorIframeComponent.$toasted;
            },

            selection()
            {
                return this.$pageComponent().selection;
            },

            itemSelector()
            {
                return this.editableData.itemSelector || '> *';
            },

        }

    }

</script>